<template>
    <div id="contact-page">
        <!--================ About History Area  =================-->
        <section class="about_history_area section_gap append_gap">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 d_flex align-items-center">
                        <div class="about_content " style="width:100%">
                            <h2 class="title title_color">About Us <br><small>  + contact with</small></h2>
                            <p class="about_contact_info">地址｜954 台東縣卑南鄉富山村杉原70號<br/>
                            電話｜<a href="tel:089-281613">+886 89 281 613</a><br/>
                            官方LINE｜<a href="line://ti/p/@bmj3918o">@bmj3918o </a><br/>
                            粉絲專頁FB｜<a href="https://www.facebook.com/Rich.Sunshine.Inn/" target="_blank">@Rich.Sunshine.Inn</a><br/><br/>
                            * 直接聯繫時間 : open 10am - 8pm <br/>
                            * 請勿在非聯繫時間內，來電詢問訂房<br/>
                            * 若需來電請留意時間(不要奪命連環摳)，若無法立即接聽，可利用LINE留言告訴我們您的需求，我們將盡快為您答覆
                            </p>
                            <img src="../assets/lineQRcode.jpg" alt="lineQRcode" style="width:120px;" /><div>官方LINE｜QRCODE</div>
                            
                        </div>
                    </div>
                    <div class="col-md-6">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3676.9411340125184!2d121.18292331426615!3d22.841667285045006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x2a60322a4e284e40!2z5Y-w5p2x5a-M5p2J5pm05rCR5a6_IFJJQ0ggU1VOU0hJTkUgSU5O!5e0!3m2!1szh-TW!2sus!4v1540634760725" width="100%" height="500" frameborder="0" style="border:0" allowfullscreen></iframe>
                    </div>
                </div>
                <div class="row about_travel_intro">
                    <div class="col-md-12 d_flex align-items-center">
                        <div class="about_content ">
                            <h2 class="title title_color"></h2>
                            <p>位於台東最美麗海岸線-台11縣的山林間，擁有絕佳的地理位置與便利的旅遊網絡，距離台東市區只需15分鐘，附近即有富山護魚區、加路蘭遊憩區、水往上流及都蘭新東糖廠等景點。距離台東火車站僅需25分鐘車程。擁有面向東部兩個海灣-都蘭灣與杉原灣的遼闊海景、並且坐擁壯闊山脈的舒活海景民宿。</p>
                        </div>
                    </div>
                    <!-- <div class="col-md-12">
                        <div><a href="https://goo.gl/maps/Vw8shfA8zot" title="導航去" target="_blank">都蘭、7-11</a> | 10分鐘</div>
                        <div><a href="" title="導航去" target="_blank">富岡漁港、海產</a> | 10分鐘</div>
                        <div><a href="https://goo.gl/maps/AUVgo477bzH2" title="導航去" target="_blank">台東市區</a>｜15分鐘</div>
                        <div><a href="https://goo.gl/maps/oY5xZcqtoAQ2" title="導航去" target="_blank">東河包子</a>｜20分鐘</div>
                        <div><a href="https://goo.gl/maps/Lj5WVFvejeP2" title="導航去" target="_blank">台東火車站</a>｜25分鐘</div>
                        <div><a href="https://goo.gl/maps/ki9aH2uXTwB2" title="導航去" target="_blank">台東豐年機場</a>｜30分鐘</div>
                        <div><a href="https://goo.gl/maps/XsD1Fq2FdKQ2" title="導航去" target="_blank">知本溫泉</a>｜35分鐘</div>
                        <div><a href="" title="導航去" target="_blank">鹿野高台、熱氣球</a>｜50分鐘</div>
                    </div> -->
                </div>

                <div class="contact-way">
                    <div class="contact-way-area row justify-content-around">
                        <div class="way-by-public contact-way-type col-md-5">
                            <div class="way-name">客運</div>
                            <div class="short-border"></div>
                            <div class="way-detail">
                                <div>台東轉運站-富杉晴</div>
                                搭乘:台灣好行[東部海岸線]，至「富山保育區」站下車<br/>
                                搭乘:鼎東客運[8103往成功]，至「富山漁業區」站下車<br/>
                                往前走約2分鐘，再向左轉彎入上坡約750公尺，即抵達。
                            </div>
                            <div class="way-detail">
                                <div>台東火車站-富杉晴</div>
                                搭乘:台灣好行[東部海岸線]，至「富山保育區」站下車<br/>
                                搭乘:鼎東客運[8103往成功]，至「富山漁業區」站下車<br/>
                                往前走約2分鐘，再向左轉彎入上坡約750公尺，即抵達。
                            </div>
                            <div class="way-detail">
                                <div>台東航空站-富杉晴</div>
                                搭乘:普悠瑪客運[陸海空快線]，至「台東火車站」站下車<br/>
                                再轉搭乘台東火車站-富杉晴路線，即抵達。<br/>
                                或<br/>
                                搭乘:普悠瑪客運[陸海空快線]/ 鼎東客運[8128]，至「台東轉運站」站下車<br/>
                                再轉搭乘台東轉運站-富杉晴路線，即抵達。
                            </div>
                        </div>
                        <div class="way-by-private contact-way-type col-md-5">
                            <div class="way-name">開車</div>
                            <div class="short-border"></div>
                            <div class="way-detail">
                                <div>北上</div>
                                自台東市往北走，沿著中華大橋接東海岸台11線，經富岡、杉原至富山護漁區，往北約30公尺後，向左轉彎入上坡約750公尺，即抵達。
                            </div>
                            <div class="way-detail">
                                <div>南下</div>
                                一. 國道5號-蘇澳交流道下.自花蓮市接台11線至，都蘭往南6公里附近，向左轉彎入上坡約750公尺，即抵達。<br/>
                                二. 國道5號-蘇澳交流道下.自花蓮市接台9線轉玉長公路至台11線，至都蘭往南6公里附近，向左轉彎入上坡約750公尺，即抵達。
                            </div>
                            <div class="way-detail">
                                <div>計程車</div>
                                台東火車站-富杉晴: 大約500元<br/>
                                台東航空站-富杉晴: 大約550元<br/>
                                <small>上述為預估花費，建議於搭乘計程車前，先行詢問司機。</small><br/>
                                <small>火車站和航空站基本上都有排班計程車哦。</small>
                            </div>
                        </div>
                    </div>
                    <div class="contact-way-area row justify-content-around">
                        <div class="way-by-other contact-way-type col-md-5">
                            <div class="way-name">其他</div>
                            <div class="short-border"></div>
                            <div class="way-detail">
                                <div>目前無提供任何至民宿的接駁服務</div>
                                <div>如有租車自駕需求，我們有配合的租車公司，可於完成訂房後聯繫客服。</div>
                            </div>
                        </div>
                        <div class="way-by-other contact-way-type col-md-5"></div>
                    </div>
                </div>
            </div>
        </section>
        <!--================ About History Area  =================-->
    </div>
</template>

<script>

export default {
  name: 'contact',
  components: {}
}
</script>
<style lang="scss">
$contact-info-color: #2f2f2f;
.about_contact_info {
    max-width: 300px;
    margin: auto;
    text-align: left;
}
.about_travel_intro {
    text-align: left;
    border-top: 2px solid;
    margin-top: 20px;
}
#contact-page {
    .contact-way {
        padding: 5rem 16px;
        background: rgba(0, 0, 0, 0.1);
        position: relative;
        // &:before {
        //     content: '';
        //     position: absolute;
        //     top: 0;
        //     /* border-bottom: 25px rgba(0, 0, 0, 0.1) solid; */
        //     border-right: 25px rgba(0, 0, 0, 0.1);
        //     border-left: 25px rgba(0, 0, 0, 0.1) solid;
        //     border-top: 25px solid white;
        //     left: 50%;
        //     margin-left: -25px;
        // }
        .title {
            font-size: 32px;
            font-weight: 100;
            color: #000;
            // margin-bottom: 5rem;
        }
        .contact-way-area .contact-way-type {
            .way-name {
                color: #FF6161;
                font-size: 18px;
                text-align: center;
                transition: 1s ease;
            }
            .way-detail {
                margin-top: 10px;
                & > div {
                    font-weight: 600;
                }
            }
            .short-border {
                width: 4rem;
                height: 1px;
                background: #FF6161;
                margin: .5rem auto 2rem auto;
            }
            // padding: 5rem 4.5rem;
            // background: rgba(4, 81, 132, 1);
            // color: white;
            // font-weight: 100;
            letter-spacing: 1px;
            text-align: left;
            transition: 1s ease;
            margin-bottom: 60px;
            // &:hover {
            //     background: #000;
            //     .way-name {
            //         font-size: 32px;
            //     }
            // }
        }
        .contact-way-direction {
            img {
                width: 80%;
                max-width: 600px;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/Transport.vue